import Model from './Model'

export default class LayoutModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'layouts'
  }
}
